import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import ProfilePage from "./user-profile/ProfilePage";
import languages from "../resources/languages.json";
import { Trans } from "react-i18next";
import ActionButton from "../components/ActionButton";

const styles = (theme) => ({
  paper: {
    minWidth: 1100,
    maxWidth: 1500,
  },
});

export class AddUserDialog extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  state = {
    userState: {},
    saveButtonDisable: true,
  };

  render() {
    const { classes } = this.props;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.onClose}
        classes={{ paper: classes.paper }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          <Trans i18nKey="user_admin_create_user_header" />
        </DialogTitle>
        <DialogContent>
          <ProfilePage
            currentUser={{}}
            organization={this.props.organization}
            hideSave
            stateUpdated={this.stateUpdated}
            isCreate
            saveButtonDisable={this.saveButtonDisable}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.props.onClose}
            color="primary"
            id="cancel-add-user"
          >
            <Trans i18nKey="global_cancel" />
          </Button>
          <ActionButton
            disabled={this.state.saveButtonDisable}
            onClick={() => this.props.onSubmit(this.state.userState)}
            loading={this.props.saving}
            color="primary"
            id="save-user"
          >
            <Trans i18nKey="global_save" />
          </ActionButton>
        </DialogActions>
      </Dialog>
    );
  }

  saveButtonDisable = (value) => {
    this.setState({ saveButtonDisable: value });
  };

  stateUpdated = (state) => {
    this.setState({ userState: state });
  };
}

export default withStyles(styles)(AddUserDialog);
